import React from 'react';
import { createPortal } from 'react-dom';
import { usePortalTarget } from '@/components/PortalTarget';
import {
  FeedbackLoadingSpinnerProps,
  FeedbackLoadingOverlayProps,
} from '@/types/components';

export const FeedbackLoadingSpinner: React.FC<FeedbackLoadingSpinnerProps> = ({
  size = 'medium',
  className = '',
  color = 'primary',
}) => {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-6 w-6',
    large: 'h-8 w-8',
  };

  const colorClasses = {
    primary: 'border-primary border-t-transparent',
    white: 'border-white border-t-transparent',
    gray: 'border-gray-300 border-t-gray-600',
  };

  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div
        className={`animate-spin rounded-full border-2 ${sizeClasses[size]} ${colorClasses[color]}`}
      />
    </div>
  );
};

export const FeedbackLoadingOverlay: React.FC<FeedbackLoadingOverlayProps> = ({
  message = 'Loading...',
  isVisible = true,
}) => {
  // Hook before the early return; inside a `showModal()` dialog the overlay
  // must render in the dialog, otherwise it is inert under the top layer.
  const portalTarget = usePortalTarget();
  if (!isVisible) return null;

  return createPortal(
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center shadow-xl">
        <FeedbackLoadingSpinner size="large" />
        <p className="mt-4 text-gray-600 font-medium">{message}</p>
      </div>
    </div>,
    portalTarget
  );
};
